import { render, staticRenderFns } from "./BrokersSelector.vue?vue&type=template&id=f525698c&"
import script from "./BrokersSelector.vue?vue&type=script&lang=js&"
export * from "./BrokersSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports